import React, { useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";

const UpgradePlanPopUp = ({ setUpgradePopUp, handleUpgradePopUp }) => {
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          if (
            event.srcElement.className ===
            "duration-picker time-picker-modal chemical-popup"
          ) {
            setUpgradePopUp(false);
          }
        }
      };
      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  return (
    <div className="duration-picker time-picker-modal chemical-popup">
      <div ref={wrapperRef}>
        <div className="time-keeper-popup duration-popup">
          <h6>Need to upgrade your subscription plan</h6>

          <div className="event-popup-btn footer-btn view-btn">
            <Button
              className="appointment-btn btn-edit"
              type="button"
              onClick={() => setUpgradePopUp(false)}
            >
              Cancel
            </Button>
            <Button
              type="Submit"
              className="appointment-btn btn-save"
              onClick={() => handleUpgradePopUp()}
            >
              Continue
            </Button>
          </div>

          {/* <div className="time-keeper-btn">
              <Button className="appointment-btn btn-edit" onClick={() => setUpgradePopUp(false)}>Cancel</Button>
              <Button onClick={() => handleUpgradePopUp()}>Yes</Button>
            </div> */}
        </div>
      </div>
    </div>
  );
};
UpgradePlanPopUp.propTypes = {
  setUpgradePopUp: PropTypes.isRequired,
  handleUpgradePopUp: PropTypes.isRequired,
};
export default UpgradePlanPopUp;
